import { render } from "./Idefined.vue?vue&type=template&id=54da34bc&scoped=true"
import script from "./Idefined.vue?vue&type=script&lang=js"
export * from "./Idefined.vue?vue&type=script&lang=js"

import "./Idefined.vue?vue&type=style&index=0&id=54da34bc&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54da34bc"]])

export default __exports__